import { defineStore } from 'pinia';
import { computed, reactive, ref, shallowRef } from 'vue';
import type { InterviewSchedulingEvent } from './types/interview-scheduling-event.type';

export const useInterviewSchedulingStore = defineStore('interview-scheduling', () => {
  const currentJobApplicantHasOngoingThread = ref<boolean>(false);
  const recentLocations = ref<string[]>([]);
  const scheduledEvents = ref<InterviewSchedulingEvent[]>([]);
  const scheduledEventsConversationId = ref<number | null>(null);
  const scheduledEventsFetchPromise = shallowRef<Promise<void> | null>(null);

  const validationErrors = reactive({
    contacts: undefined as string | undefined,
    customMeetingLink: undefined as string | undefined,
  });

  const hasValidationErrors = computed(() => {
    return !!(validationErrors.contacts || validationErrors.customMeetingLink);
  });

  const resetValidationErrors = () => {
    validationErrors.contacts = undefined;
    validationErrors.customMeetingLink = undefined;
  };

  return {
    currentJobApplicantHasOngoingThread,
    hasValidationErrors,
    recentLocations,
    resetValidationErrors,
    scheduledEvents,
    scheduledEventsConversationId,
    scheduledEventsFetchPromise,
    validationErrors,
  };
});
